import React from "react";

export const SampleQuestion = ({ text, color }) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-start",
      gap: 6,
      marginBottom: 6,
    }}
  >
    <span style={{ color, marginTop: 2, fontSize: 12 }}>→</span>
    <span style={{ fontSize: 12.5, fontWeight: 600, color }}>{text}</span>
  </div>
);